import React, { Component } from "react";
// import logo from "./logo.svg";
import AuthProvider from './auth.js';
import PeerjsProvider from './peerContext.js';
import CallProvider from './callContext.js';
import AudioProvider from './Audio.js';
import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";

//----------components-------------

// import Navbar from './components/layouts/navbar';
import Sandbox from './sandbox';
// import Landing from './components/landing/landing';
import Login from './components/Authentication/login';
import Register from './components/Authentication/register';
import Education from './components/education/education';
import Cigerate from './components/education/cigerate';
import Alcohol from './components/education/alcohol';
import Marijuana from './components/education/marijuana';
import Hashish from './components/education/hashish';
import Heroine from './components/education/heroine';
import Cocaine from './components/education/cocaine';
import Meth from './components/education/meth';
import Ameth from './components/education/Ameth';
import Mdma from './components/education/mdma';
import Opioids from './components/education/opioids';
import Depressants from './components/education/depressants';
import Lsd from './components/education/lsd';
import Pcp from './components/education/pcp';

import Faq from './components/faq/faq';
import Addstory from './components/stories/addfamilystory';
import AddPeoplestory from './components/stories/addpeoplestory';
// import Forum from './components/forum/forum';
import SingleFamilyStory from './components/stories/SingleFamilyStory';
// import PeopleStories from './components/stories/familyStories';
import RehabCenters from "./components/rehabPages/rehabs";
import AddRehab from "./components/rehabPages/addRehabs";
import IRehabPage from './components/rehabPages/SingleRehabPage';

import Familystories from "./components/storyRoute/FamilyStories";
import DependantStories from './components/storyRoute/DependantStories';
import StoryTypes from './components/routingPages/storyTypes';

import EducationExplore from './components/education/educationexplore';
import EducationTreatment from './components/education/eduexploretreatment';
import EducationAddiction from './components/education/eduexploreaddiction';

import StoryEduForum from './components/routingPages/storyeduforum';

import CallPick from './components/callPage/callpick';
import CallCancel from './components/callPage/callcancel';
import landingPage from "./components/landingPage/landingPage";
import Bot from "./components/chatBot/chatBot";
import PeopleStories from "./components/stories/peoplestories";
import Query from './components/faq/query.js';


// ---------------------------- counsellor routes -----------------------------------//
import CounsellorDashboard from './components/counsellor/dashboard/dashboard';
import CounsellorLogin from './components/counsellor/counsellorLogin';
import CounsellorRegister from './components/counsellor/counsellorRegister';
import Diagnosiscriteria from './components/counsellor/diagnosisCriteria';
import Ethics from './components/counsellor/ethics';
// import Counsellorusers from './components/counsellor/users';
import Counsellorprofile from './components/counsellor/counsellorProfile';
import Patientprofile from './components/counsellor/patientprofile';
import counsellorQueries from './components/counsellor/query/counsellorQuery';

// import UserInfo from './components/chatBot/information';
import Developers from './components/developers/developers';
import CounsellorChat from './components/chat/chatDasboard';
import UserProfile from './components/chat/userProfile';


import AddForum from './components/familyForum/addForum';
import Forums from './components/familyForum/forum';
import Displayforum from './components/familyForum/displayForum';

import Resources from './components/resources/resources';

import UserInfo from './components/offline/information';
import myOffline from './components/offline/mycouncellors';
import offlineMembers from './components/offline/members';//used members not patients to not hurt the people's sentiments
// import { User } from "parse";

const Parse = require('parse');
Parse.initialize("qd38MDMw9L37yUVcliBemAjSW6YosSXzNeOMH6C6",
  "SijHUPTfvwXJsCYWHGW86TTDUdi3qmYyxlWsvnUm");

Parse.serverURL = "https://aid.back4app.io";



console.log("Parse initialised")


class App extends Component {

  render() {
    return (
      <Router >
        <AuthProvider>
          <AudioProvider>
          <PeerjsProvider>
            <CallProvider>

              
            {/* <PeerProvider> */}
            <div className='App'>

              <Route exact path="/" component={landingPage} />


              <Route exact path="/chat" component={Bot} />


              <Route exact path="/call" component={Sandbox} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/register" component={Register} />

              {/* education route start ------------ */}
              <Route exact path="/educationexplore/" component={EducationExplore} />
              <Route exact path="/education/addiction" component={EducationAddiction} />
              <Route exact path="/education/treatment" component={EducationTreatment} />
              <Route exact path="/education/" component={Education} />
              <Route exact path="/education/cigerate" component={Cigerate} />
              <Route exact path="/education/alcohol" component={Alcohol} />
              <Route exact path="/education/marijuana" component={Marijuana} />
              <Route exact path="/education/hashish" component={Hashish} />
              <Route exact path="/education/heroine" component={Heroine} />
              <Route exact path="/education/cocaine" component={Cocaine} />
              <Route exact path="/education/meth" component={Meth} />
              <Route exact path="/education/ameth" component={Ameth} />
              <Route exact path="/education/mdma" component={Mdma} />
              <Route exact path="/education/opioids" component={Opioids} />
              <Route exact path="/education/lsd" component={Lsd} />
              <Route exact path="/education/pcp" component={Pcp} />
              <Route exact path="/education/depressants" component={Depressants} />
              {/* education route end ------------ */}

              {/* stories routes start --------------*/}
              <Route exact path="/stories" component={StoryTypes} />
              <Route exact path="/explore" component={StoryEduForum} />
              <Route exact path="/familystories/person/:id" component={SingleFamilyStory} />
              <Route exact path="/dependantstories/person/:id" component={PeopleStories} />
              <Route exact path="/familystories/addstory" component={Addstory} />
              <Route exact path="/peoplestories/addstory" component={AddPeoplestory} />
              <Route exact path="/familystories/route" component={Familystories} />
              <Route exact path="/dependantstories/route" component={DependantStories} />
              {/* stories route end */}

              {/* rehab pages start -------------- */}
              <Route exact path="/rehab/:id" component={IRehabPage} />
              <Route exact path="/rehabs" component={RehabCenters} />
              <Route exact path="/addsecret/rehabs" component={AddRehab} />
              {/* rehab pages end -------------- */}

              <Route exact path="/faq" component={Faq} />

              {/* Family forum start ----------- */}
              <Route exact path="/forum" component={Forums} />
              <Route exact path="/forumadd"  component={AddForum} />
              <Route exact path="/forum/:id" component={Displayforum} />              
              {/* Family forum end ------------- */}

              {/* <Route exact path="/forum" component={Forum} /> */}

              {/* call routes start --------------- */}
              <Route exact path="/incoming" component={CallPick} />
              <Route exact path="/decline/:id" component={CallCancel} />
              {/* call routes end ----------------- */}
              <Route exact path="/queries" component={Query} />
              <Route exact path="/resources" component={Resources} />
              
              <Route exact path="/about" component={Developers}/>

              {/* offline start  ----------------- */}
              {/* <Route exact path="/offline" component={UserInfo}/> */}
              <Route exact path='/offline' component={UserInfo}/>
              <Route exact path="/myoffline" component={myOffline}/>
              <Route exact path="/myoffline/:id" component={myOffline}/>
              <Route exact path="/offline/members" component={offlineMembers} />
              <Route exact path="/counsellorchat/:id" component={CounsellorChat} />
              <Route exact path="/userprofile" component={UserProfile} />
              
              {/* offline end  ----------------- */}
            </div>



            {/* ------------------ counsellor dashboard ---------------*/}
            <Route exact path="/counsellor/" component={CounsellorDashboard} />
            <Route exact path="/counsellor/login" component={CounsellorLogin} />
            <Route exact path="/counsellor/register" component={CounsellorRegister} />
            <Route exact path="/counsellor/diagnosis" component={Diagnosiscriteria} />
            <Route exact path="/counsellor/ethics" component={Ethics} />
            {/* <Route exact path="/counsellor/users" component = {Counsellorusers} /> */}
            <Route exact path="/counsellor/profile" component={Counsellorprofile} />
            <Route exact path="/counsellor/patient/:id" component={Patientprofile} />
            <Route exact path="/counsellor/queries" component={counsellorQueries} />
            {/* <Route exact path="/counsellor/:id" component={counsellorInfo} /> */}


            </CallProvider>
          </PeerjsProvider>
          </AudioProvider>
        </AuthProvider>
      </Router>
    );
  }
}

export default App;
